const Cross =
    "M24 9.6L22.4 8 16 14.4 9.6 8 8 9.6l6.4 6.4L8 22.4 9.6 24l6.4-6.4 6.4 6.4 1.6-1.6-6.4-6.4z";

export default Cross;
